import React from 'react';
import {hashCode} from 'polyphony/util';

export const getStyle = domNode => {
   let ret = {};
   for (const [k, v] of Object.entries({...domNode.style})) {
       if (!v) continue;
       if (v.length === 0) continue;
       if (!Number.isNaN(parseInt(k))) continue;
       ret[k] = v;
   }
   return ret;
};

export const getAttrs = domNode => {
    let attrs = domNode.attributes;
    let ret = {};
    for (const a of [...attrs]) {
        const name = a.name;
        ret[name] = name === 'style' ? getStyle(domNode) : a.value;
    }
    return ret;
};

export const unwrapDom = node => {
    if (Array.isArray(node)) {
        return [...node].map(unwrapDom).flat();
    }

    switch (node.nodeType) {
        case Node.ELEMENT_NODE: return [node];
        case Node.DOCUMENT_FRAGMENT_NODE: return [...node.childNodes].map(unwrapDom).flat();
        case Node.CDATA_SECTION_NODE: return [node.textContent];
        case Node.TEXT_NODE: return [node.textContent];
        default: return [];
    }

};

export const toReactNode = (node, f = undefined, key = 0) => {
    if (typeof node !== 'object') return node;
    if (!node) return null;
    if (React.isValidElement(node)) return node;

    const reactKey = `${key}__${hashCode(JSON.stringify(node))}`;

    if (f) node = f(node, cs => cs.map(c => toReactNode(c, f)));

    if (React.isValidElement(node)) {
        return React.cloneElement(node, {key: reactKey});
    }

    if (!node) return null;

    const {attributes, tag, children} = node;
    const {class: className, 'for': htmlFor, ...xs} = attributes;

    let props = {...xs, className, htmlFor, key: reactKey};
    let reactChildren = children.map((c, idx) => toReactNode(c, f, idx));
    if (reactChildren && reactChildren.length > 0) return React.createElement(tag, props, reactChildren);
    return React.createElement(tag, props);
};

// Takes an HTML string, and returns a DocumentFragment representing it.
export const htmlToFragment = x => document.createRange().createContextualFragment(x);

// Takes a DOM tree, and parses it into an AST.
export const parseTree = tree => unwrapDom(tree).map(el => {
    if (typeof el === 'string') return el;
    return {
        tag: el.tagName.toLowerCase(),
        attributes: getAttrs(el),
        children: [...el.childNodes].map(parseTree).flat()
    };
});

export const treeToReact = (tree, f) => tree.map((t, idx) => toReactNode(t, f, idx));

export const parseHTML = (html, f) => treeToReact(parseTree(htmlToFragment(html)), f);

